import React from 'react';
import { Typography, Image, Row, Col, Divider } from 'antd';
import { styles } from '../../../styles';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import RelatedBlog from './RelatedBlogs';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog5() {
  const matches = useMediaQuery('(min-width: 768px)');

  return (
    <>
    <Row style={styles.navLinks}>        
      <p><Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ The Effect of Caitlin Clark<span></span></p>
    </Row>
    <Row justify="center">
      <Col xs={24} sm={22} md={20} lg={16}>

        <div style={styles.blogContainer}>
          <Typography>
            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            The Effect  <a href="https://time.com/7200904/athlete-of-the-year-2024-caitlin-clark/" rel="noreferrer" target='_blank'>Caitlin Clark</a> Effect
            </Title>
            <Paragraph style={styles.blogParagraph}>
            Very few women basket players have been successful to get the international popularity and name. For years the women <a href="https://www.britannica.com/list/the-10-greatest-basketball-players-of-all-time">basketball players </a> have been struggled to get the recognition that the male basketball players have got over decades.             
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            Even though both games need equal physical strength and athleticism but still they were nowhere need to be same. But this year, thanks to the one female player that brought the attention to the women basketball at international level and provide it a global recognition. The name of the player is Caitlin Clark.             </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            Who is already considered as the one of the greatest player of all the time? This is not just a vain title but it has many reasons but there is a reason it is called <a href="https://time.com/7200904/athlete-of-the-year-2024-caitlin-clark/" rel="noreferrer" target='_blank'>“Caitlin Clark Effect”</a> because it has brought the unimaginable attention to women basketball.
            </Paragraph>

            <Image
              preview={false}
              src="https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/the-caitlin-clark-effect.webp"
              alt="Editorial illustration for a feature on Caitlin Clark and women’s basketball"
              style={{ borderRadius: '8px', width: matches ? '75%' : '95%', margin: '10px' }}
            />

            <Paragraph style={styles.blogParagraph}>
            When we talk about the all-time NCAA top scorer then the name that stood out is the Caitlin Clark, she was successful to surpass the record with 3667 points, and she passed the previous top scorer Pete Maravich.  She has multiple records under her belt , which has helped her to become one of the greatest of all the time , one of that record is most points scored in women’s NCAA Division in one season .
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            She also holds the record for having most points scored in women’s tournament in all time. These records speak for itself. That’s why she has already became one of the greatest player of all time.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            She left a huge mark in college <Link to="/fixtures/NBA/NBA">basketball</Link> then she moved to WNBA. Unsurprisingly she was the number one over all pic in 2024 WNBA draft. She was selected by the Indiana’s club Fever.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            After joining the WNBA Caitlin Clark has successfully changed the game. That is why people call it the Caitlin Clark effect because she has changed the women basketball matches. She has helped to bring the attention to the match. She has increased the viewership and attendance. 
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            Playing in her club Indiana Fever, she has set many records. When she debut in his first match she helped to increase the viewership to nearly 200%. This shows that her being part of WNBA has increased the TV ratings. Not only that, with her popularity, she has brought it many new fans to WNBA.
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            It is undeniable that Clark has unmatchable star power, which she has used to make the women <Link to="/fixtures/NBA/NBA">basketball</Link> more popular. Many new fans who previously were not interested in the WNBA has now been drawn to the WNBA because of the electrifying performances of the Caitlin Clark .along with that, she has helped to motivate and excite that existing fans , for years the female basketball players have been ignored , the fans were disappointed . They had almost given up, but with time and with the presence of the glory of Caitlin Clark things have changed for them.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            They are more exciting for it than ever. In short it is Caitlin Clark that there is economic change, now fans are more excited, T ratings has been increased and viewership has skyrocket. Now fans are waiting for the second season of the <Link to="/fixtures/NBA/NBA">WNBA</Link>. They are more interested to see the star power and athleticism of their favorite players, who has proved herself to be one of the greatest player of the time in just one season.
            </Paragraph>
            
            <Divider />
            <Title level={4} style={{...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
              Read More Below
            </Title>
            <div style={{ paddingRight: '10px' }}>
              <RelatedBlog excludedId={5} />
            </div>

            <BlogFooter />
          </Typography>
        </div>
      </Col>
    </Row>
    </>
  );
}
